
import capitalizeFirstLetter from "~/mixins/capitalizeFirstLetter";
import benefits from "../benefits/benefits.vue";
import { mapGetters } from "vuex";
export default {
  components: { benefits },
  mixins: [capitalizeFirstLetter],
  props: {
    pageTitle: String,
    offers: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      arrSet: "marks/marks/arrSet",
    }),
    isSet() {
      let set;
      if (
        this.arrSet.includes(this.$route.params.mark) &&
        this.$route.params.mark
      ) {
        set = this.$route.params.mark;
        return set;
      }
      return false
    },
    isHideSorts() {
      return this.$route?.params?.mark === 'created-at-c'
    }
  }
};
